import React, { FunctionComponent } from 'react'
import { AnalyticsIcon } from '../icons/analyticsIcon'

export interface Props {
  title: string
  icon: string
  onClick: () => void
}

const hubIcon = (icon: string) => {
  switch (icon) {
    case 'icon-analytics':
      return (
        <div className="hub-link__icon">
          <AnalyticsIcon />
        </div>
      )
    default:
      return <div className={`hub-link__icon ${icon}`} />
  }
}

export const HubButton: FunctionComponent<Props> = ({
  title,
  icon,
  onClick,
}) => {
  return (
    <div className="hub-link">
      <button
        type="button"
        onClick={onClick}
        className="hub-link__link hub-link__button"
        style={{
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          width: '100%',
          padding: 0,
          display: 'block',
        }}
      >
        <div className="hub-link__box">{hubIcon(icon)}</div>
      </button>
      <div className="hub-link__title">
        <p>{title}</p>
      </div>
    </div>
  )
}
